
import "@/styles/icons/material-icons/material-icons.css";

import { defineComponent } from "vue";

import { mapWritableState, mapActions } from "pinia";
import { useBillStore } from "@/stores/BillStore";

import FindStep from "./components/FindStep.vue";
import CheckStep from "./components/CheckStep.vue";
import WaitPaymentDialog from "./components/WaitPaymentDialog.vue";

export default defineComponent({
  name: "LayoutDefault",
  components: { FindStep, CheckStep, WaitPaymentDialog },

  data: () => ({
    division: window.onlDivision || undefined,
    APIKey: window.onlAPIKey || undefined,

    startLoading: false,
  }),

  computed: {
    ...mapWritableState(useBillStore, ["billData", "paymentTypes", "step"]),
    bg() {
      return window.onlBillTheme?.background;
    },
  },

  methods: {
    ...mapActions(useBillStore, ["checkPayment", "getPaymentTypes"]),
  },
  async created() {
    this.startLoading = true;
    await this.getPaymentTypes();

    if (window.onlBillPayments?.length) {
      const filteredPayments = [] as any;

      window.onlBillPayments.forEach((type) => {
        console.log(type);

        const founded = this.paymentTypes.find((t) => {
          if (t.paymentKey == type) return t;
        });

        if (founded) filteredPayments.push(founded);
      });

      console.log(filteredPayments);

      // const filtered = this.paymentTypes.filter((type) => {
      //   return window.onlBillPayments?.includes(type.paymentKey);
      // });

      this.paymentTypes = filteredPayments;
    }

    ///// тип оплаты по умолчанию

    if (this.paymentTypes?.length && this.paymentTypes[0])
      this.billData.paymentType = this.paymentTypes[0];

    /////

    const urlParams = new URLSearchParams(window.location.search);

    const paymentId = urlParams.get("paymentId") || undefined;
    const paramToken = urlParams.get("session") || undefined;
    const division = urlParams.get("division") || undefined;
    const returnResult = urlParams.get("return") || undefined;
    if (
      paramToken &&
      paymentId &&
      returnResult === "success" &&
      division == window.onlDivision
    ) {
      await this.checkPayment(paramToken, Number(paymentId));
    }

    /////
    const num = urlParams.get("bill") || undefined;
    const pin = urlParams.get("pin") || undefined;
    if (num && pin) {
      this.billData.num = num;
      this.billData.pin = pin;
    }

    this.startLoading = false;
  },
});
